import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/compliance/')({
  component: ComplianceIndex,
});

function ComplianceIndex() {
  return <Navigate to="/compliance/dashboard" replace />;
}
